import type {AriaCheckboxProps, AriaPopoverProps} from 'react-aria';
import {useCheckbox} from 'react-aria';
import React, {useRef} from "react";
import {type OverlayTriggerState, useToggleState} from 'react-stately';

interface CheckboxProps extends Omit<AriaCheckboxProps, 'popoverRef'> {
    className?: string;
}

export function Checkbox(props: CheckboxProps) {

    const {children, isRequired, isDisabled, className} = props;
    const ref = useRef(null);
    const state = useToggleState(props);
    const {
        inputProps,
        isInvalid,
        validationErrors
    } = useCheckbox(props, state, ref);

    return (
        <div className={className}>
            <label className={`flex items-center gap-2 ${isDisabled ? 'field-disabled' : 'cursor-pointer'}`}>
                <div className={`${isDisabled ? 'field-disabled' : ''}`}>
                    <input {...inputProps} ref={ref}
                           className={'field-input flex-shrink-0 w-4 h-4 rounded-md'}
                           style={{
                               border: '1px solid var(--color-field-border)',
                               boxShadow: 'var(--shadow-field)',
                               backgroundColor: 'var(--color-field-background)',
                               accentColor: 'black'
                           }}
                           type="checkbox" />
                </div>

                {children && (
                    <span className={`field-label-checkbox ${isDisabled ? 'field-disabled' : ''}`}>
                        {children}
                        {isRequired && <span className={'field-required'}>*</span>}
                    </span>
                )}
            </label>

            {/*{props.description && (*/}
            {/*    <div className={'mt-2 text-xs ml-6'}>*/}
            {/*        {props.description}*/}
            {/*    </div>*/}
            {/*)}*/}

            {isInvalid && (
                <div className={'field-error ml-6'}>
                    {validationErrors.join(' ')}
                </div>
            )}
        </div>
    );
}